export default function Logo({ variant = "light", size = 30, withWordmark = true }) {
  const ink = variant === "dark" ? "#0A1128" : "#F5F2EB";
  const gold = "#C5A059";
  const sage = "#9CAE96";
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* Upward trend line — three ascending peaks */}
        <path
          d="M4 26 L11 20 L16 23 L22 14 L28 8"
          stroke={gold}
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        {/* Trend node dots */}
        <circle cx="11" cy="20" r="1.8" fill={ink} />
        <circle cx="16" cy="23" r="1.8" fill={ink} />
        <circle cx="22" cy="14" r="1.8" fill={ink} />
        {/* Rising trajectory arrow head at peak */}
        <path d="M28 8 L24 8 M28 8 L28 12" stroke={gold} strokeWidth="2.2" strokeLinecap="round" />
        {/* AI spark — 4-point star */}
        <path
          d="M30 4 L30.9 6.4 L33.2 7 L30.9 7.6 L30 10 L29.1 7.6 L26.8 7 L29.1 6.4 Z"
          fill={gold}
        />
        {/* Sage grounding tick */}
        <circle cx="4" cy="26" r="1.6" fill={sage} />
      </svg>
      {withWordmark && (
        <div className="leading-none">
          <span className="font-serif text-[15px] font-semibold tracking-tight" style={{ color: ink }}>
            TrendRise
          </span>
          <span className="font-serif text-[15px] font-semibold ml-1 italic" style={{ color: gold }}>
            AI
          </span>
        </div>
      )}
    </div>
  );
}
